$(document).ready(function () {
    $(document).on("click", ".js-usermanagement-lostpw-toggle", function () {
        $(".js-usermanagement-email").val($(".js-usermanagement-username").val());
    });
});